module.exports = __webpack_public_path__ + "img/sLD_Token_voucher_80k_matic.6ae93e19.png";